import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatDateTime } from '@/Utils/LocalizedDateFormat';
import { useCallback, useState, useEffect } from 'react';
import { ApplicationEvent } from '@standardnotes/snjs';
import { isSameDay } from '@/Utils';
import Button from '@/Components/Button/Button';
import PreferencesGroup from '../../PreferencesComponents/PreferencesGroup';
import PreferencesSegment from '../../PreferencesComponents/PreferencesSegment';
import { Title, Text } from '../../PreferencesComponents/Content';
import { c } from 'ttag';
const Protections = ({ application }) => {
    const enableProtections = () => {
        application.clearProtectionSession().catch(console.error);
    };
    const [hasProtections, setHasProtections] = useState(() => application.hasProtectionSources());
    const getProtectionsDisabledUntil = useCallback(() => {
        const protectionExpiry = application.getProtectionSessionExpiryDate();
        const now = new Date();
        if (protectionExpiry > now) {
            if (isSameDay(protectionExpiry, now)) {
                return formatDateTime(protectionExpiry, {
                    hour: 'numeric',
                    minute: 'numeric',
                });
            }
            return formatDateTime(protectionExpiry, {
                weekday: 'long',
                day: 'numeric',
                month: 'short',
                hour: 'numeric',
                minute: 'numeric',
            });
        }
        return null;
    }, [application]);
    const [protectionsDisabledUntil, setProtectionsDisabledUntil] = useState(getProtectionsDisabledUntil());
    useEffect(() => {
        const removeUnprotectedSessionBeginObserver = application.addEventObserver(async () => {
            setProtectionsDisabledUntil(getProtectionsDisabledUntil());
        }, ApplicationEvent.UnprotectedSessionBegan);
        const removeUnprotectedSessionEndObserver = application.addEventObserver(async () => {
            setProtectionsDisabledUntil(getProtectionsDisabledUntil());
        }, ApplicationEvent.UnprotectedSessionExpired);
        const removeKeyStatusChangedObserver = application.addEventObserver(async () => {
            setHasProtections(application.hasProtectionSources());
        }, ApplicationEvent.KeyStatusChanged);
        return () => {
            removeUnprotectedSessionBeginObserver();
            removeUnprotectedSessionEndObserver();
            removeKeyStatusChangedObserver();
        };
    }, [application, getProtectionsDisabledUntil]);
    if (!hasProtections) {
        return null;
    }
    return (_jsx(PreferencesGroup, { children: _jsxs(PreferencesSegment, { children: [_jsx(Title, { children: c('B6.Preferences.Security.Title').t `Protections` }), protectionsDisabledUntil ? (_jsx(Text, { className: "text-info", children: c('B6.Preferences.Security.Status').jt `Unprotected access expires at ${protectionsDisabledUntil}.` })) : (_jsx(Text, { className: "text-info", children: c('B6.Preferences.Security.Status').t `Protections are enabled.` })), _jsx(Text, { className: "mt-2", children: c('B6.Preferences.Security.Info')
                        .t `Actions like viewing or searching protected notes, exporting decrypted backups, or revoking an active session require additional authentication such as entering your account password or application passcode.` }), protectionsDisabledUntil && (_jsx(Button, { className: "mt-3", primary: true, label: c('B6.Preferences.Security.Action').t `End Unprotected Access`, onClick: enableProtections }))] }) }));
};
export default Protections;
